import React, { useState } from 'react';
import SanctionForTestModal from './SanctionForTestModal';

interface Props {
  detail: any;
  onSuccess: () => void;
}

const SanctionForTestCard: React.FC<Props> = ({ detail, onSuccess }) => {
  const [showSanctionModal, setShowSanctionModal] = useState(false);

  return (
    <>
      <div className="bg-[#F3F5FC] rounded-xl p-6 flex items-center justify-between border border-gray-200">
        <div className="flex items-center gap-6">
          <img src="/images/sanction-test.png" alt="Sanction for Test" className="w-28 h-auto" />

          <div>
            <h3 className="text-lg font-semibold text-gray-800">Sanction for Test</h3>
            <p className="text-sm text-gray-600 max-w-2xl mt-2">Click the button to initiate the Sanction for test process.</p>
          </div>
        </div>

        <button
          onClick={() => setShowSanctionModal(true)}
          className="px-8 py-2 border border-blue-500 text-blue-600 rounded-md hover:bg-blue-50 font-medium"
        >
          Start
        </button>
      </div>

      <SanctionForTestModal
        open={showSanctionModal}
        onClose={() => setShowSanctionModal(false)}
        permitData={detail}
        onSubmit={() => {
          setShowSanctionModal(false);
          onSuccess();
        }}
      />
    </>
  );
};

export default SanctionForTestCard;
